<template>
  <div>
    <van-tabs v-model="activeName" sticky animated>
      <van-tab :key="item.CateNO" v-for="item in Work_Resource.$1" :title="item.CateDesc"
               :name="item.CateNO">
        <div style="display: flex;">
          <van-sidebar sticky v-model="item.activeKey" :key="item.CateNO+'_Sidebar'"
                       @change="(index)=>onChangeSideBar(index,item)">
            <van-sidebar-item v-for="tag in item.Tags" :key="item.CateNO+'_'+tag.text" :title="tag.text"/>
          </van-sidebar>
          <div class="content">
            <van-search @input="filter" :clearable="false" v-model="keywords"
                        placeholder="请输入搜索关键词(支持拼音首字母搜索)"/>
            <div class="content_list" :style="contentHeight">
              <div v-for="content in Work_Resource.$3" class="content_item"
                   v-if="content.CateNO == item.CateNO && content.Tag ==  item.Tags[item.activeKey].text">
                <div class="title">{{ content.Memo }}</div>
                <div class="detail" v-for="dtl in Work_Resource.$4"
                     v-if="dtl.ResourceNO == content.ResourceNO">
                  <div class="resource resource_text" v-if="dtl.ResourceType == 'text'">
                    {{ dtl.Resource }}
                  </div>
                  <div class="resource" v-if="dtl.ResourceType == 'image'">
                    <van-image @click="previewImage(dtl)"
                               width="60"
                               height="60"
                               :src="dtl.Resource"
                    />
                    <div style="padding-left: 12px">图片</div>
                  </div>
                  <div class="resource" v-if="dtl.ResourceType == 'video'">
                    <van-image
                        width="60"
                        height="60"
                        :src="dtl.Resource"
                    />
                    <div style="padding-left: 12px">视频</div>
                  </div>
                  <div class="tools">
                    <van-button @click="send(dtl)" type="primary" size="small">发送</van-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </van-tab>
    </van-tabs>
  </div>
</template>

<script>

export default {
  props: {
    objectName: {
      type: String
    },
  },
  created() {
    this.get_data()
    let _this = this
    window.addEventListener('resize', function () {
      _this.resize()
    });
    setTimeout(() => {
      _this.resize()
    }, 500)
  },
  data() {
    return {activeName: "", Work_Resource: {}, Work_Resource_copy: {}, contentHeight: 500, keywords: ""};
  },
  methods: {
    previewImage(item) {
      vant.ImagePreview({images: [item.Resource], closeable: true});
    },
    filter() {
      if (!this.keywords || this.keywords.length == 0) {
        this.Work_Resource.$4 = JSON.parse(JSON.stringify(this.Work_Resource_copy.$4))
        this.Work_Resource.$3 = JSON.parse(JSON.stringify(this.Work_Resource_copy.$3))

      } else {
        let _fd = this.$utils.pinyinFilter(this.Work_Resource_copy.$4, "MemoResource", this.keywords);
        let _$3 = []
        let _$4 = []
        for (let i = 0; i < _fd.length; i++) {
          let _row = _fd[i]
          let _Has$3 = _$3.filter(x => x.ResourceNO == _row.ResourceNO)
          if (_Has$3.length == 0) {
            _$3 = _$3.concat(this.Work_Resource_copy.$3.filter(x => x.ResourceNO == _row.ResourceNO))
          }

          let _Has$4 = _$4.filter(x => x.ResourceNO == _row.ResourceNO)
          if (_Has$4.length == 0) {
            _$4 = _$4.concat(this.Work_Resource_copy.$4.filter(x => x.ResourceNO == _row.ResourceNO))
          }
        }

        this.Work_Resource.$3 = _$3
        this.Work_Resource.$4 = _$4
      }
    },
    resize() {
      let _height = window.innerHeight - 44 - 54
      this.contentHeight = "height:" + _height + "px"
    },
    onChangeSideBar(index, item) {
      this.$forceUpdate()
    },
    async get_data() {
      this.Work_Resource = await this.$frame.getDataObjectData(this.objectName)
      for (let i = 0; i < this.Work_Resource.$1.length; i++) {
        let _item = this.Work_Resource.$2.filter(x => x.CateNO == this.Work_Resource.$1[i].CateNO)
        this.Work_Resource.$1[i].Tags = []
        this.Work_Resource.$1[i].activeKey = 0
        for (let j = 0; j < _item.length; j++) {
          this.Work_Resource.$1[i].Tags.push({text: _item[j].Tag})
        }
      }

      this.Work_Resource_copy = JSON.parse(JSON.stringify(this.Work_Resource))

    },
    send(dtl) {
      if (dtl.ResourceType == 'image' || dtl.ResourceType == 'video') {
        this.$wxWork.sendImage(dtl)
      } else if (dtl.ResourceType == 'text') {
        this.$wxWork.sendText(dtl)
      }
    }
  },
};
</script>

<style lang="less">
.detail {
  display: flex;
  align-items: center;
}

.resource {
  flex: 1;
  white-space: break-spaces;
}

.tools {
  width: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content {
  flex: 1;
}

.content_list {
  overflow: scroll;
}

.title {
  color: #6e6c6c;
  font-size: 12px;
  font-weight: bold;
}

.content_item {
  padding: 12px;
  border-bottom: 2px solid #ddd;
}

.resource {
  display: flex;
  align-items: center;
  font-size: 10px;
}

.resource_text {
  overflow: hidden;
  text-overflow: ellipsis;
  max-height: 45px;
}


.title, .resource {
  padding: 6px;
  border-bottom: 1px dotted #ddd;
}
</style>
